import { useEffect, useState } from 'react';
import moment from 'moment';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';


import { useForm } from '../../../../shared/hooks/Form';
import { ToastService } from '../../../../AppToast';
import { useDataTable } from '../../../../shared/hooks/DataTable';
import { RegisterInvoiceService } from '../../../../service/invoice/RegisterInvoiceService';
import { InvoiceService } from '../../../hoa-don/InvoiceService';
import { useTranslation } from '../../../../shared/language';


const validateTaxCode = value => {
  let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
  if (value.length > 10) {
    patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
  }
  if (value === "") return true;
  if (patt.test(value) === false) {
    return false;
  }
  const number = Number(value.charAt(0)) * 31 + Number(value.charAt(1)) * 29 + Number(value.charAt(2)) * 23
    + Number(value.charAt(3)) * 19 + Number(value.charAt(4)) * 17 + Number(value.charAt(5)) * 13
    + Number(value.charAt(6)) * 7 + Number(value.charAt(7)) * 5 + Number(value.charAt(8)) * 3;

  return (10 - number % 11) === Number(value.charAt(9));
}

export const DialogSelectInvoiceDiscounted = (props) => {

  const { t } = useTranslation();

  const { display, setDisplay, addSelectedItems, invoiceStatus, sendTaxStatus = '2,4', registerInvoice } = props;

  const [invoiceSerials, setInvoiceSerials] = useState([]);

  const [requiredParams, setRequiredParams] = useState(null);

  useEffect(() => {
    RegisterInvoiceService.getUsingList({ maxResultCount: 1000 }).then(({ items }) => {
      console.log("🚀 ~ RegisterInvoiceService.getUsingList ~ items:", items)
      const _invoiceSerials = [];
      items.forEach(item => {
        _invoiceSerials.push({ value: item.symbolCode, label: item.symbolCode });
      });
      setInvoiceSerials(_invoiceSerials);
    });

  }, []);

  const { render: renderForm, setValue, getValue } = useForm({
    fields: [
      { field: 'invoiceSerial', header: t('common.symbol'), type: 'Dropdown', DropdownProps: { options: invoiceSerials, filter: true, resetFilterOnHide: true }, className: 'md:col-3', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'fromDate', header: t('common.fromDate'), type: 'Calendar', className: 'md:col-3', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8' },
      { field: 'toDate', header: t('common.toDate'), type: 'Calendar', className: 'md:col-3', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8' },
      { field: 'buyerTaxCode', header: t('common.taxCode'), className: 'md:col-3', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8', disabled: true }
    ],
    layout: 'Horizontal'
  });

  const search = () => {
    const searchValue = getValue();
    if (!validateTaxCode(searchValue.buyerTaxCode || '')) {
      return ToastService.error(t('validation.taxCodeInvalid'));
    }
    if (invoiceStatus) {
      searchValue.invoiceStatus = invoiceStatus;
    }
    if (sendTaxStatus) {
      searchValue.sendTaxStatus = sendTaxStatus;
    }
    setRequiredParams(searchValue);
  }

  const { render: renderDataTable, selectedItems, clearItems } = useDataTable({
    header: '',
    dataKey: 'id',
    columns: [
      {
        field: 'invoiceStatus', header: t('common.status'), width: 110, matchMode: 'contains', filterType: 'dropdown', filterOptions: InvoiceService.invoiceStatuses, dataType: 'custom', customCell(rowData: any): any {
          return <span className={`invoice-status invoice-status-${rowData.invoiceStatus}`}>{InvoiceService.getInvoiceStatusLabel(rowData.invoiceStatus)}</span>;
        }
      },
      { field: 'invoiceSerial', header: t('common.symbol'), width: 100, matchMode: 'contains' },
      { field: 'invoiceDate', header: t('common.invoiceDate'), width: 110, dataType: 'date' },
      { field: 'invoiceNumber', header: t('common.invoiceNo'), width: 110, matchMode: 'contains' },
      {
        field: 'buyerLegalName', header: t('common.buyerName'), minWidth: 250, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return rowData.buyerLegalName || rowData.buyerDisplayName;
        }
      },
      { field: 'buyerTaxCode', header: t('common.taxCode'), width: 110, matchMode: 'contains', },
      { field: 'taxAuthorityCode', header: t('common.taxAuthorityCode'), width: 150, matchMode: 'contains' }
    ],
    heightCalc: 350,
    requiredParams,
    getList: (params) => {
      const { mst, ...filteredParams } = params; // Remove the 'mst' field from params
      return InvoiceService.getList({ ...filteredParams, loadAll: true });
    },
    selectionMode: 'checkbox',
  });

  useEffect(() => {
    if (display) {
      setValue({
        invoiceSerial: registerInvoice.invoiceSerial,
        invoiceNumber: '',
        fromDate: null,
        toDate: null,
        buyerTaxCode: registerInvoice.buyerTaxCode,
      });
      clearItems();
    }
  }, [display]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = () => {
    if (!selectedItems) {
      return ToastService.error(t('common.selectInvoice'));
    }
    addSelectedItems(selectedItems);
  }

  return (
    <Dialog
      header={t('common.selectInvoice')}
      visible={display}
      style={{ width: '90rem' }}
      draggable={false}
      resizable={true}
      position="top"
      onHide={() => setDisplay(false)}
    >
      <div className="grid">
        <div className="col-11">
          {renderForm()}
        </div>
        <div className="col-1">
          <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={search} />
        </div>
        <div className="col-12">
          {renderDataTable()}
        </div>
      </div>

      <div className="flex justify-content-end">
        <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm" />
        <Button label={t('common.receive')} icon="pi pi-check" onClick={handleSubmit} className="p-button-sm" />
      </div>
    </Dialog>
  );
}
